import React, { useEffect, useState } from "react";

function DTOLoans() {
  return <></>;
}
export default DTOLoans;
